import { Divider, Stack } from '@mui/material';
import { PurchaseAgreementsTable } from '@retail/purchase-agreements/components';
import { useCallback, useState } from 'react';
import { PurchaseAgreement } from '@retail/purchase-agreements/types';
import { useFetchPurchaseAgreements } from '@retail/purchase-agreements/data-access';
import { SuspenseWithSentryErrorBoundary } from '@retail/components';
import { PriceListTableContainer } from './PriceListTableContainer';

interface Props {
  assortmentId: number;
  supplierId: number;
  comparePriceLists: boolean;
}

export function AgreementsWithPriceComparison({
  assortmentId,
  supplierId,
  comparePriceLists,
}: Props) {
  const { data: purchaseAgreementsDto = [] } = useFetchPurchaseAgreements({ supplierId });
  const purchaseAgreements = purchaseAgreementsDto.map(PurchaseAgreement.fromDto);

  const [checkedAgreements, setCheckedAgreements] = useState<PurchaseAgreement[]>(
    purchaseAgreements[0] ? [purchaseAgreements[0]] : []
  );

  const handleCheckAgreement = useCallback(
    (agreement: PurchaseAgreement) => {
      setCheckedAgreements((prev) => {
        const checkedAgreementIds = checkedAgreements.map((agreement) => agreement.id);
        if (checkedAgreementIds.includes(agreement.id)) {
          return prev.filter((checkedAgreement) => checkedAgreement.id !== agreement.id);
        }
        return prev.concat(agreement);
      });
    },
    [checkedAgreements]
  );

  return (
    <Stack flexDirection="row" justifyContent="space-between" flexGrow={1} overflow="hidden">
      <PurchaseAgreementsTable
        agreements={purchaseAgreements}
        compareMode={comparePriceLists}
        checkedAgreements={checkedAgreements}
        handleCheckAgreement={handleCheckAgreement}
      />

      {comparePriceLists && <Divider orientation="vertical" flexItem />}
      {comparePriceLists && (
        <Stack width="75%">
          <SuspenseWithSentryErrorBoundary>
            <PriceListTableContainer
              assortmentId={assortmentId}
              selectedAgreementIds={checkedAgreements.map((agreement) => agreement.id)}
              selectedAgreements={checkedAgreements}
              checkedPriceType={'CURRENT'}
              includeSearchField
            />
          </SuspenseWithSentryErrorBoundary>
        </Stack>
      )}
    </Stack>
  );
}
